export default "__VITE_ASSET__CZtLWgb0__"